import axios from '../api';
import router from '../router';

export default {
  namespaced: true,

  state: {
    listPageTemplates:[],
    listModulesPages:[],
    modulesPagesTemplates: [],

    saved: false,
    saving: false,

    infosPage:{
      id_page: 0,
      id_module: 0,
      id_template: 0,
      libelle_module: '',
      libelle_template: '',
      name_module: '',
      name_page: '',
      type_ref: '',
      is_active: 0,
      keep_name:'',
      isTemplateChanged: false, //to know if there is change in form. If it's true, a message will appear
    },

    templateContent:[],
    /*baseTemplateContent:[], */
    templateVersions:[],

    evaluationInProgress: false,

    loading: false,
    messageHeader: null,


    listAssignedUsersTemplate: [],
  },

  getters: {
    saved(state){
      return state.saved;
    },

    saving(state){
      return state.saving;
    },

    listModulesPages(state){
      return state.listModulesPages;
    },

    listPageTemplates(state){
      return state.listPageTemplates;
    },

    infosPage(state){
      return state.infosPage;
    },

    loading(state){
      return state.loading;
    },

    messageHeader(state){
      return state.messageHeader;
    },

    templateContent(state){
      return state.templateContent;
    },

    templateVersions(state){
      return state.templateVersions;
    },
    evaluationInProgress(state){
      return state.evaluationInProgress;
    },

    listAssignedUsersTemplate(state){
      return state.listAssignedUsersTemplate;
    }
  },

  mutations: {
    SET_SAVED(state, saved){
      state.saved = saved;
    },

    SET_SAVING(state, bool){
      state.saving = bool;
    },

    SET_LISTMODULESPAGES(state, modules){
      state.listModulesPages = modules;
    },

    SET_LISTPAGETEMPLATES(state, templates){
      state.listPageTemplates = templates;
    },

    SET_INFOSPAGE(state, infos){
      state.infosPage = infos;
    },

    SET_LOADING(state, loadornot){
      state.loading = loadornot;
    },

    SET_MESSAGEHEADER(state, msg){
      state.messageHeader = msg;
    },

    SET_LIBELLE_TEMPLATE(state, name){
      state.infosPage.libelle_template = name;
    },

    SET_NAME_TEMPLATE_IN_LIST(state, infos){
      if(state.listPageTemplates.filter(t => t.id == infos[0])[0].name != infos[1]){
        state.listPageTemplates.filter(t => t.id == infos[0])[0].name = infos[1];
        state.infosPage.isTemplateChanged = true;
      }
    },

    SET_TEMPLATEVERSIONS(state, templates){
      state.templateVersions = templates;
    },

    SET_TEMPLATECONTENT(state, template){
      state.templateContent = template;
    },

    SET_ISACTIVE(state, isActive){
      state.infosPage.is_active = isActive;
      state.listPageTemplates.filter(t => t.id == state.infosPage.id_template)[0].is_active = isActive;
    },
    SET_EVALUATIONINPROGRESS(state, inProgress){
      state.evaluationInProgress = inProgress;
    },

    SET_EVALUATION_FIELD(state, field){
      state.templateContent[field[0]][field[1]] = true;
    },
    SET_LISTASSIGNEDUSERSTEMPLATE(state, list){
      state.listAssignedUsersTemplate = list;
    }
  },

  actions: {
    async loadModulesPages(context){
      console.log('wait...loadModulesPages');
      await axios.get('/api/modules/getModulesPages/neopass/0').then((response) => {
        context.commit('SET_LISTMODULESPAGES', response.data);
      }).catch(error => {
        console.log('ERRRR:: ',error.response.data);
      });
    },

    async save_datas(context, datas) {
      console.log('wait...save_datas');
            
      context.commit('SET_SAVING', true);

      let infosPage = context.getters.infosPage;

      await axios.put('/api/page_templates/'+infosPage.id_template, {page: infosPage, data: datas}).then((response) => {
        if(response.data != ''){
          context.commit('SET_MESSAGEHEADER', {type:'success', msg: response.data});
          context.commit('SET_SAVED', true);
          context.getters.infosPage.isTemplateChanged = false;
        }
        context.dispatch('load_datas');
        context.commit('SET_SAVING', false);
        setTimeout(() => {context.commit('SET_MESSAGEHEADER', null);}, (response.data).length*100);
      })
        .catch(error => {
          context.commit('SET_SAVING', false);
          switch (error.response.status) {
          case 406:
            context.commit('SET_MESSAGEHEADER', {type:'error', msg:'Ce modèle de page ne peut pas être modifié.' });
            break;
          case 403:
            context.commit('SET_MESSAGEHEADER', {type:'error', msg:'Vous n\'êtes pas autorisé à modifier ce modèle de page.' });
            break;
          default:
            context.commit('SET_MESSAGEHEADER', {type:'error', msg:'Une erreur est survenu dans l\'enregistrement de vos données.' });
            break;
          }

          setTimeout(() => {context.commit('SET_MESSAGEHEADER', null);}, 3000);
        });
    },

    async reactivate_template(context, version){
      let versions = context.getters.templateVersions;
      let old_version = versions[version];

      context.commit('SET_LIBELLE_TEMPLATE', old_version[0].name);

      old_version.splice(0, 1); // remove first entry corresponding information for history

      context.commit('SET_TEMPLATECONTENT', old_version);
      context.dispatch('save_datas', old_version);
      context.getters.infosPage.isTemplateChanged = false;
    },

    async add_template(context, infos){
      await axios.put('/api/page_templates/add_template/'+infos.page+'/'+infos.type).then((response) => {
        router.push({ name: response.data.type, params: { id_template: response.data.id } });
        context.dispatch('load_pages');
      }).catch(error => {
        console.log('ERRRR:: ',error.response.data);
      });
    },

    async load_pages(context){
      console.log('wait...load_page_templates');
      await axios.get('/api/page_templates').then((response) => {
        context.commit('SET_LISTPAGETEMPLATES', response.data);
      }).catch(error => {
        console.log('ERRRR:: ',error.response.data);
      });
    },

    async update_infos_page(context, url){
      let template;
      console.log('wait...update_infos_page');
      if(url[0] == 'default'){
        if(context.getters.listPageTemplates.filter(t => t.module_name == url[2]).filter(m => m.page_name == url[3]).length > 0){
          template = context.getters.listPageTemplates.filter(t => t.module_name == url[2]).filter(m => m.page_name == url[3])[0];
        }else if(context.getters.listPageTemplates.filter(t => t.module_name == url[2]).length > 0){
          template = context.getters.listPageTemplates.filter(t => t.module_name == url[2])[0];
        }else{
          template = context.getters.listPageTemplates[0];
        }
      }else if(context.getters.listPageTemplates.filter(t => t.id == url[0]).length > 0){
        template = context.getters.listPageTemplates.filter(t => t.id == url[0])[0];
      }else{
        template = context.getters.listPageTemplates[0];
      }

      let infos = {
        id_page: template.page_id,
        id_module: template.module_id,
        id_template: template.id,
        libelle_module: template.module_libelle,
        libelle_template: template.name,
        editable:template.editable,
        deletable:template.deletable,
        name_module: url[2],
        name_page: url[3],
        type_ref: url[1],
        is_active: template.is_active,
        keep_name: template.name,
        isTemplateChanged: false,
      };

      context.commit('SET_INFOSPAGE', infos);

      await axios.get('api/page_templates/verifyInProgress/'+template.id).then((response) => {
        if(response.data){
          context.commit('SET_EVALUATIONINPROGRESS', true);
        }
        if(!response.data){
          context.commit('SET_EVALUATIONINPROGRESS', false);
        }
      }).catch(error => {
        console.log('ERRRR:: ', error.response.data);
      });

      await axios.get('api/page_templates/assignedUsersTemplateList/'+template.id).then((response) => {
        context.commit('SET_LISTASSIGNEDUSERSTEMPLATE', response.data);
      }).catch(error => {
        console.log('ERRRR:: ', error.response.data);
      });
    },

    async load_datas(context){
      console.log('wait...load_datas');
      let infosPage = context.getters.infosPage;

      await axios.get('/api/page_templates/'+infosPage.id_template).then((response) => {
        /* Load datas for the form */
        let datas = response.data.data;
        if(datas.length > 0 && datas[0] != null){ // if no version, datas = [null] and datas.length = 1
          context.commit('SET_TEMPLATECONTENT', datas[datas.length-1]);
          context.commit('SET_SAVED', false);
          if(datas.length > 1){
            console.log('SET_TEMPLATEVERSIONS');
            datas.splice(-1,1);
            context.commit('SET_TEMPLATEVERSIONS', datas);
          }
          else{
            context.commit('SET_TEMPLATEVERSIONS', []);
          }
        }else{
          context.commit('SET_TEMPLATEVERSIONS', []);
          context.commit('SET_TEMPLATECONTENT', []);
          context.commit('SET_SAVED', false);
        }
      }).catch(error => {
        console.log('ERRRR:: ', error);
      });
    },

    async delete_template(context, newTemplateToAssign){
      if(!context.getters.evaluationInProgress){
        if(context.getters.listPageTemplates.filter(t => t.page_id == context.getters.infosPage.id_page && t.is_active == 1).length > 1){

          if(context.getters.listAssignedUsersTemplate.length > 0 && newTemplateToAssign != null){
            await axios.delete('/api/page_templates/deleteAndReplace/'+context.getters.infosPage.id_template+'/'+newTemplateToAssign.id).then(() => {
              context.dispatch('first_load_page');
            }).catch(error => {
              console.log('ERRRR:: ', error.response.data);
            });
          }
          else{
            await axios.delete('/api/page_templates/'+context.getters.infosPage.id_template).then(() => {
              context.dispatch('first_load_page');
            }).catch(error => {
              console.log('ERRRR:: ', error.response.data);
            });
          }

          let firsttemplate = context.getters.listPageTemplates.filter(t => t.module_id === context.getters.infosPage.id_module)[0];
          router.push({ name: firsttemplate.type, params: { id_template: firsttemplate.id, module: firsttemplate.module_name, page: firsttemplate.page_name  } });
        } // END if at least one active for this page
        else{
          context.commit('SET_MESSAGEHEADER', {type:'error', msg: 'Vous ne pouvez pas supprimer le dernier modèle de ce type'});
          setTimeout(() => {context.commit('SET_MESSAGEHEADER', null);}, 3000);
        }
      } // END if there isn't evaluation in progress
    },

    async switchState(context, datas = {state: false, newTemplateToAssign: null}){
      if(!context.getters.evaluationInProgress){
        if(context.getters.listPageTemplates.filter(t => t.page_id == context.getters.infosPage.id_page && t.is_active == 1).length <= 1
                    && datas.state == 0 ){
          context.commit('SET_MESSAGEHEADER', {type:'error', msg: 'Vous ne pouvez pas désactiver le dernier modèle de ce type'});
          setTimeout(() => {context.commit('SET_MESSAGEHEADER', null);}, 3000);
        }
        else{
          if(context.getters.listAssignedUsersTemplate.length > 0 && datas.newTemplateToAssign != null){
            await axios.get('/api/page_templates/switchAndReplace/'+context.getters.infosPage.id_template+'/'+datas.newTemplateToAssign.id).then((response) => {
              context.commit('SET_ISACTIVE', response.data);
              context.commit('SET_MESSAGEHEADER', {type:'success', msg: 'Le modèle de page "'+context.getters.infosPage.libelle_template+'" a bien été '+ (response.data == 0 ? 'désactivé' : 'activé')});
              setTimeout(() => {context.commit('SET_MESSAGEHEADER', null);}, 3000);
              context.dispatch('first_load_page');
            }).catch(error => {
              console.log('ERRRR:: ', error.response.data);
            });
            await axios.get('api/page_templates/assignedUsersTemplateList/'+context.getters.infosPage.id_template).then((response) => {
              console.log('set list assigned users template with SWITCH', response.data);
              context.commit('SET_LISTASSIGNEDUSERSTEMPLATE', response.data);
            }).catch(error => {
              console.log('ERRRR:: ', error.response.data);
            });
          }
          else{
            await axios.get('/api/page_templates/switch/'+context.getters.infosPage.id_template).then((response) => {
              context.commit('SET_ISACTIVE', response.data);
              context.commit('SET_MESSAGEHEADER', {type:'success', msg: 'Le modèle de page "'+context.getters.infosPage.libelle_template+'" a bien été '+ (response.data == 0 ? 'désactivé' : 'activé')});
              setTimeout(() => {context.commit('SET_MESSAGEHEADER', null);}, 3000);
              context.dispatch('first_load_page');
            }).catch(error => {
              console.log('ERRRR:: ', error.response.data);
            });
          }
        }
      }
    },

    checkContent(context, url) {
      if (!context.getters.infosPage.isTemplateChanged){
        return true; //go to next page
      }else {
        context.commit('SET_MESSAGEHEADER', {type:'INPUT', msg: 'Vous avez des modifications non sauvegardées', url: url});
        return !context.getters.infosPage.isTemplateChanged;
      }
    },

    async first_load_page(context){
      await context.dispatch('load_pages');
      await context.dispatch('loadModulesPages');
    },

    async change_page(context, url){
      await context.dispatch('load_pages');
      await context.dispatch('update_infos_page', url);
      await context.dispatch('load_datas');
    },
  }
};
